import React, { useState } from "react";
import CustomModal from "../customModal/customModal";
import { Tab, Nav, Button } from "react-bootstrap";
import { Input } from "../../ui";
import { toast } from "react-toastify";
import {
  useCreateTeamMutation,
  useFetchAllTeamsByUserQuery,
  useAddTeamMemberMutation,
  useFetchProfilesQuery,
  useDeleteTeamMemberMutation,
} from "../../store/api/apiSlice";
const MyTeam = ({ isModalOpen2, setIsModalOpen2 }) => {
  const { data: profileData } = useFetchProfilesQuery();
  const [activeTab, setActiveTab] = useState("myTeam");
  const [nameFields, setNameFields] = useState([
    { firstName: "", lastName: "" },
  ]);
  const [teamName, setTeamName] = useState("");
  const [isModalOpenAdd, setIsModalOpenAdd] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState(null);

  const [createTeam] = useCreateTeamMutation();
  const {
    data: teamsdata,
    error,
    isLoading,
    refetch,
  } = useFetchAllTeamsByUserQuery(profileData?.user?._id);
  const [deleteTeamMember] = useDeleteTeamMemberMutation();
  const [addTeamMember] = useAddTeamMemberMutation();

  const handleCloseModalAdd = () => {
    setIsModalOpenAdd(false);
    setNameFields([{ firstName: "", lastName: "" }]);
  };

  const handleOpenModalAdd = (team, member) => {
    setSelectedTeam(team);

    setIsModalOpenAdd(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen2(false);
  };
  const handleAddMoreClick = () => {
    setNameFields([...nameFields, { firstName: "", lastName: "", Email: "" }]);
  };

  const handleNameFieldChange = (index, field, value) => {
    const updatedFields = [...nameFields];
    updatedFields[index][field] = value;
    setNameFields(updatedFields);
  };

  const handleRemoveField = (index) => {
    const updatedFields = nameFields.filter((_, i) => i !== index);
    setNameFields(updatedFields);
  };
  const handleSubmit = async () => {
    const teamData = {
      name: teamName,
      userId: profileData?.user?._id,

      teamMembers: nameFields.map((field) => ({
        firstName: field.firstName,
        lastName: field.lastName,
        email: "dummy@gmail.com",
      })),
    };

    try {
      await createTeam(teamData).unwrap();

      refetch();
      setTeamName("");

      setNameFields([{ firstName: "", lastName: "" }]);
      toast.success("Team created successfully!");
    } catch (error) {
      const errorMessage = error?.data?.error || "Failed to create team.";

      const validationErrors = errorMessage.split(", ");
      const messages = validationErrors
        .map((err) => {
          const match = err.match(/Path `(.+)` is required/);
          return match ? `${match[1]} is required.` : null;
        })
        .filter(Boolean);

      if (messages.length > 0) {
        toast.error(messages[0]);
      } else {
        toast.error("Failed to create team.");
      }
    }
  };
  const handleSubmit2 = async () => {
    const newMembers = nameFields.map((field) => ({
      firstName: field.firstName,
      lastName: field.lastName,
    }));

    try {
      await addTeamMember({ TeamID: selectedTeam._id, newMembers }).unwrap();
      toast.success("Member Added successfully!");
      refetch();
      handleCloseModalAdd();
    } catch (error) {
      toast.error("Failed to add team members ");
    }
  };
  const handleDeleteMember = async (teamId, memberId) => {
    try {
      await deleteTeamMember({ TeamId: teamId, Memberid: memberId }).unwrap();
      toast.success("Member removed successfully!");
      refetch();
    } catch (error) {
      toast.error("Failed to remove member.");
    }
  };
  return (
    <>
      <CustomModal isOpen={isModalOpen2} onClose={handleCloseModal}>
        <h3 className="myTeam_h3Text"> Teams </h3>

        <Tab.Container
          className="myTeam_TabCont"
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
        >
          <Nav variant="tabs">
            <Nav.Item>
              <Nav.Link eventKey="myTeam">My Team</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="createTeam">Create Team</Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content>
            <Tab.Pane eventKey="myTeam">
              <div className="myTeam_Tabevent">
                {teamsdata && teamsdata?.teams.length > 0 ? (
                  teamsdata &&
                  teamsdata?.teams.map((team, index) => (
                    <div
                      key={index}
                      className="myTeam_Container myTeam_Tabevent_item"
                    >
                      <div className="myTeam_Tabevent_item2">
                        <h5>{team.name}</h5>
                        <h6
                          className="myTeam_Tabevent_item2_h6"
                          onClick={() => handleOpenModalAdd(team)}
                        >
                          +
                        </h6>
                      </div>

                      {team.teamMembers.map((member, idx) => (
                        <li key={idx} className="myTeam_Tabevent_item2_li">
                          <h5 className="myTeam_Tab_Names">
                            <span className="myTeam_Tab_NamesSpan">
                              {member.firstName} {member.lastName}
                            </span>
                          </h5>
                          <h5
                            className="myTeam_Tab_Namesh5"
                            onClick={() =>
                              handleDeleteMember(team._id, member._id)
                            }
                          >
                            X
                          </h5>
                        </li>
                      ))}
                    </div>
                  ))
                ) : (
                  <div className="myTeam_Noteam">
                    <h4>No Team is created</h4>
                  </div>
                )}
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="createTeam">
              <div className="myTeam_create_cont">
                <Input
                  placeholder="Team Name"
                  label="Team Name"
                  type="text"
                  value={teamName}
                  onChange={(e) => setTeamName(e.target.value)}
                  style={{ marginRight: "10px" }}
                />
              </div>

              {nameFields.map((field, index) => (
                <div className="myTeam_nameField">
                  <div className="myTeam_nameField1">
                    <Input
                      placeholder="First Name"
                      label="First Name"
                      type="text"
                      style={{ marginRight: "10px" }}
                      value={field.firstName}
                      onChange={(e) =>
                        handleNameFieldChange(
                          index,
                          "firstName",
                          e.target.value
                        )
                      }
                    />
                  </div>
                  <div className="myTeam_nameField1">
                    <Input
                      placeholder="Last Name"
                      label="Last Name"
                      type="text"
                      style={{ marginRight: "10px" }}
                      value={field.lastName}
                      onChange={(e) =>
                        handleNameFieldChange(index, "lastName", e.target.value)
                      }
                    />
                  </div>

                  <div>
                    <button
                      onClick={() => handleRemoveField(index)}
                      className="Minus-btn myTeam_reduceBtn"
                    >
                      -
                    </button>
                  </div>
                </div>
              ))}
              <div className="myTeam_Add_cont">
                <a className="myTeam_Add_btn" onClick={handleAddMoreClick}>
                  Add More
                </a>
              </div>
              <div className="col-5 myTeam_Submit">
                <Button style={{ marginLeft: "-10px" }} onClick={handleSubmit}>
                  Submit
                </Button>
              </div>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </CustomModal>
      <CustomModal isOpen={isModalOpenAdd} onClose={handleCloseModalAdd}>
        <div className="myTeam_custom">
          <Input
            placeholder="Team Name"
            label="Team Name"
            type="text"
            value={selectedTeam ? selectedTeam.name : ""}
            readOnly
            style={{ marginRight: "10px" }}
          />
        </div>

        {nameFields.map((field, index) => (
          <div className="myTeam_NameMain">
            <div className="myTeam_NameCont">
              <Input
                placeholder="First Name"
                label="First Name"
                type="text"
                value={field.firstName}
                style={{ marginRight: "10px" }}
                onChange={(e) =>
                  handleNameFieldChange(index, "firstName", e.target.value)
                }
              />
            </div>
            <div className="myTeam_NameCont">
              <Input
                placeholder="Last Name"
                label="Last Name"
                type="text"
                value={field.lastName}
                onChange={(e) =>
                  handleNameFieldChange(index, "lastName", e.target.value)
                }
                style={{ marginRight: "10px" }}
              />
            </div>

            <div>
              <button
                onClick={() => handleRemoveField(index)}
                className="Minus-btn myTeam_reduceBtn"
              >
                -
              </button>
            </div>
          </div>
        ))}
        <div className="myTeam_Add_cont">
          <a className="myTeam_Add_btn" onClick={handleAddMoreClick}>
            Add More
          </a>
        </div>
        <div className="col-5 myTeam_Submit">
          <Button style={{ marginLeft: "-10px" }} onClick={handleSubmit2}>
            Submit
          </Button>
        </div>
      </CustomModal>
    </>
  );
};

export default MyTeam;
